<template>
  <div class="mtp-1 hgt-25" style="display: flex; justify-content: center">
    全{{ total | formatMoney }}件中{{
      (pageNum - 1) * pageSize + 1 > total
        ? (total % pageSize) * pageSize + 1
        : (pageNum - 1) * pageSize + 1
    }}～{{
      (pageNum - 1) * pageSize + pageSize > total
        ? total
        : (pageNum - 1) * pageSize + pageSize
    }}件表示
    {{
      pageNum > Math.ceil(total / pageSize)
        ? Math.ceil(total / pageSize)
        : pageNum
    }}/{{ Math.ceil(total / pageSize) }}
  </div>
</template>

<script>
export default {
  name: 'PageControl',
  props: {
    total: {
      type: Number,
      required: true
    },
    pageNum: {
      type: Number,
      required: true
    },
    pageSize: {
      type: Number,
      required: true
    }
  }
}
</script>
